import Vue from 'vue'
import { mapGetters, mapState } from 'vuex'

export const getNumberOfQuizzes = (slides) => {
  return slides
    .filter((slide) => slide.type === 'pickAnswer')
    .length
}

export const getNumberOfQuizzesHavePassed = (slides, currentSlideId) => {
  const matchSlide = slides.find((slide) => slide.id === currentSlideId)

  return slides
    .filter((slide) => slide.type === 'pickAnswer')
    .filter((slide) => slide.order <= matchSlide.order)
    .length
}

export default (component) => Vue.component('QuestionCounterContainer', {
  props: {
    isCompleted: {
      type: Boolean,
      default: false,
    },
    numberOfQuizzes: {
      type: Number,
      default: 0,
    },
    numberOfQuizzesHavePassed: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    ...mapGetters({
      slide: 'activeActivity',
    }),
    ...mapState({
      slides: (state) => state.slides,
      presentation: (state) => state.presentation,
    }),
  },
  render(createElement) {
    const { audiencePacing } = this.presentation

    // get number of quiz to show on question scence
    let numberOfQuizzes = this.slide.questionCount
    let numberOfQuizzesHavePassed = this.slide.questionIndex

    // get number of quiz to show on result scence
    if (this.isCompleted) {
      numberOfQuizzes = this.numberOfQuizzes
      numberOfQuizzesHavePassed = this.numberOfQuizzesHavePassed
    }

    // get number of quiz for audience pacing
    if (audiencePacing) {
      numberOfQuizzes = getNumberOfQuizzes(this.slides)
      numberOfQuizzesHavePassed = getNumberOfQuizzesHavePassed(this.slides, this.slide.id)
    }

    return createElement(component, {
      props: {
        ...this.$attrs,
        isCompleted: this.isCompleted,
        numberOfQuizzes,
        numberOfQuizzesHavePassed,
      },
    })
  },
})
